<div class="add-daily-meal-wrapper">
    <div class="heading-section flex flex-col md:flex-row">
        <div class="form-wrapper">
            <div class="heading ">
              Enter Screen Time
            </div>
            <div class="separator-wrapper">
                <hr class="separator">
            </div>
            <div class="p-10">
                <div class="form-control w-full flex justify-between items-center">
                    <span class="form-label min-w-[29%] max-w-[29%]">
                        Time of day<span class="asterisk ml-[0.5rem]">*</span>
                    </span>
                    <app-filter-dropdown [parentFormGroup]="form"
                                         [enableClearSelection]="true"
                                         [options]="todTypeList"
                                         [loading]="todLoading"
                                         controlName="todType"
                                         [error]="errorMessages['todType']"
                                         placeholder="Select one"
                                         type="small"
                                         class="min-w-[70%] max-w-[70%] form-field">
                    </app-filter-dropdown>
                </div>
                <div class="form-control w-full flex justify-between items-center">
                    <span class="form-label min-w-[29%] max-w-[29%]">
                        Screen Type
                    </span>
                    <app-filter-dropdown [enableClearSelection]="true"
                                         [options]="screenTypeList"
                                         [loading]="screenTypeListLoading"
                                         [parentFormGroup]="form"
                                         controlName="screenType"
                                         placeholder="Select one"
                                         type="small"
                                         class="min-w-[70%] max-w-[70%] form-field">
                    </app-filter-dropdown>
                </div>
                <div *ngIf="form.controls['screenType'].value===-1"
                     class="form-control w-full flex justify-between items-center">
                      <span class="form-label min-w-[29%] max-w-[29%]">
                          Other
                      </span>
                      <app-text-input
                        [parentFormGroup]="form"
                        controlName="screenTypeOtherValue"
                        placeholder="Mention other screen type..."
                        [error]="errorMessages['screenTypeOtherValue']"
                        type="small"
                        class="min-w-[70%] max-w-[70%] form-field">
                      </app-text-input>
                </div>
                <div class="form-control w-full flex justify-between items-center">
                    <span class="form-label min-w-[29%] max-w-[29%]">
                        Activity
                    </span>
                    <app-filter-dropdown [enableClearSelection]="true"
                                         [options]="activityTypeList"
                                         [loading]="activityTypeListLoading"
                                         [parentFormGroup]="form"
                                         controlName="activityType"
                                         placeholder="Select one"
                                         type="small"
                                         class="min-w-[70%] max-w-[70%] form-field">
                    </app-filter-dropdown>
                </div>
                <div *ngIf="form.controls['activityType'].value===-1"
                     class="form-control w-full flex justify-between items-center">
                        <span class="form-label min-w-[29%] max-w-[29%]">
                            Other
                        </span>
                  <app-text-input
                    [parentFormGroup]="form"
                    controlName="activityTypeOtherValue"
                    placeholder="Mention other activity type..."
                    [error]="errorMessages['activityTypeOtherValue']"
                    type="small"
                    class="min-w-[70%] max-w-[70%] form-field">
                  </app-text-input>
                </div>
                <div class="form-control w-full flex justify-between items-center">
                    <span class="form-time-label min-w-[29%] max-w-[29%]"
                      [class.form-time-label-error]="errorMessages['duration']">
                        Time<span class="asterisk ml-[0.5rem]">*</span>
                    </span>
                    <div class="flex flex-col">
                      <div class="flex items-center time-input">
                        <app-number-input [parentFormGroup]="form"
                                          controlName="hours"
                                          placeholder="Hrs" type="small"
                                          class="min-w-[39%] max-w-[39%] form-field">
                        </app-number-input>
                        <span class="sub-hrs-form-label">
                            Hr
                        </span>
                        <app-number-input [parentFormGroup]="form"
                                          controlName="minutes"
                                          placeholder="Mins" type="small"
                                          class="min-w-[39%] max-w-[39%] form-field">
                        </app-number-input>
                        <span class="sub-mins-form-label">
                            Min
                        </span>
                      </div>
                      <span class="time-error-text"
                            *ngIf="errorMessages['duration']">
                        {{errorMessages['duration']}}
                      </span>
                    </div>
                </div>
                <div class="form-control w-full flex justify-between items-center mt-[2rem]">
                    <span class="form-label min-w-[29%] max-w-[29%]">
                        Comments
                    </span>
                    <app-text-area-input [parentFormGroup]="form"
                                         class="min-w-[70%] max-w-[70%] form-field"
                                         controlName="comments"
                                         placeholder="Add comments (optional)"
                                         type="small"
                                         [maxLength]="2000">
                    </app-text-area-input>
                </div>

            </div>

            <div class="separator-wrapper">
                <hr class="separator">
            </div>
            <div class="w-full">
                <div class="flex justify-end">
                    <app-icon *ngIf="!form.invalid" class="action-icon" svgIcon="check-circle" (click)="addScreenType()"></app-icon>
                    <app-icon *ngIf="form.invalid" class="action-icon"
                              svgIcon="check-circle-disabled"></app-icon>
                    <app-icon class="action-icon close-icon" svgIcon="cross-red-circle"
                        (click)="closeModel()"></app-icon>
                </div>
            </div>
        </div>
        <!--   <div class="section-wrapper">
            <div class="heading ">
                Select Screen Type
            </div>
            <div class="separator-wrapper">
                <hr class="separator">
            </div>
            <div class="table-wrapper overflow-y-scroll">
                <table [dataSource]="dataSource" mat-table>
                    <ng-container [sticky]="true" matColumnDef="screenType">
                        <th *matHeaderCellDef class="min-w-[15rem]" mat-header-cell>
                            <div class="th-cell">
                                Screen Type
                            </div>
                        </th>
                        <td *matCellDef="let eachRow;let index=index" mat-cell>
                            <div class="td-cell">
                                <div class="daily-tracker-title text-wrapper">
                                    {{eachRow.screenType}}
                                </div>
                            </div>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="activity">
                        <th *matHeaderCellDef class="min-w-[10%]" mat-header-cell>
                            <div class="th-cell daily-tracker-title">
                                Activity
                            </div>
                        </th>
                        <td *matCellDef="let eachRow" mat-cell>
                            <div class="td-cell daily-tracker-content daily-tracker-title text-wrapper">
                                {{eachRow?.activity}}
                            </div>
                        </td>
                    </ng-container>
                    <tr *matHeaderRowDef="colDef; sticky: true" mat-header-row></tr>
                    <tr *matRowDef="let row; columns: colDef;" mat-row></tr>
                </table>
            </div>
        </div> -->
    </div>
</div>
